import { createContext, useContext } from "react";

/** api_reference spec, "On the internal portal the docs navigation lives in
 * the application shell's left panel": what the shell hands the docs route.
 * `host` is the element the shell renders in its left panel (null until it has
 * mounted, and while the docs module is not open); the route portals its
 * navigation into it. `skipHost` is the shell's slot before the panel, where
 * the route portals its skip links so they are the page's first focusable
 * elements. The two callbacks drive the shell's drawer below `lg`:
 * `openNavigation` opens it and moves focus into it; `closeNavigation` closes
 * it and says whether it did (at `lg` and above the panel is persistent, so it
 * does nothing and returns false). */
export interface DocsShell {
  host: HTMLElement | null;
  skipHost: HTMLElement | null;
  openNavigation: () => void;
  closeNavigation: () => boolean;
}

// The graph view (`/graph`) hands its tools to the same context, with its own host.
export const DocsShellContext = createContext<DocsShell | null>(null);

/** The shell's docs context, or `null` outside the shell (the public portal,
 * and components mounted alone). */
export function useDocsShell(): DocsShell | null {
  return useContext(DocsShellContext);
}
